/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerTypeResponse } from '../../models/customer-type-response';

export interface GetCustomerTypes$Params {
}

export function getCustomerTypes(http: HttpClient, rootUrl: string, params?: GetCustomerTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerTypeResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCustomerTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerTypeResponse>>;
    })
  );
}

getCustomerTypes.PATH = '/customer-types';
